import top from './Img/bombascalor/TOP+9 8,7KW 50HZ.jpg';
import top23 from './Img/bombascalor/TOP-+23.jpg';
import eco from './Img/bombascalor/EPN07 Inverter.jpg';
import silence from './Img/bombascalor/MS130 Inverpad.jpg';


function BombasCalor() {

  return (
    <><br/><br/><br/><br/><br/>
   <div>
    <div class="row p-2 ms-5 me-5 border-0 principalrow">
        <h5 class="card-title text-center robot pb-3 ">Bombas de calor ASTRAL - TOP +</h5>
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-4">
            <div class="card"><img src={top}
                    class="card-img-top ps-5 pe-5" alt="..."/>
                <div class="card-body body-robots">
                    <h5 class="card-title text-center robot">TOP+6 - 220V</h5>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Potencia:</div>
                        <div class="col-6">6,1 kW</div>
                    </div>
                    <div class="row  p-1">
                        <div class="col-6">Volúmen máximo:</div>
                        <div class="col-6">27 m3</div>
                    </div>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Conexión de agua:</div>
                        <div class="col-6">50mm</div>
                    </div>
                    <div class="row p-1">
                        <div class="col-6">Compatible con Wi-fi:</div>
                        <div class="col-6">SI</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-4">
            <div class="card"><img src={top}
                    class="card-img-top ps-5 pe-5" alt="..."/>
                <div class="card-body body-robots">
                    <h5 class="card-title text-center robot">TOP+9</h5>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Potencia:</div>
                        <div class="col-6">8,7 kW</div>
                    </div>
                    <div class="row  p-1">
                        <div class="col-6">Volumen máximo:</div>
                        <div class="col-6">36 m3</div>
                    </div>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Conexión de agua:</div>
                        <div class="col-6">50mm</div>
                    </div>
                    <div class="row p-1">
                        <div class="col-6">Compatible con Wi-fi:</div>
                        <div class="col-6">SI</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-4">
            <div class="card"><img src={top}
                    class="card-img-top ps-5 pe-5" alt="..."/>
                <div class="card-body body-robots">
                    <h5 class="card-title text-center robot">TOP+14</h5>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Potencia:</div>
                        <div class="col-6">14 kW</div>
                    </div>
                    <div class="row  p-1">
                        <div class="col-6">Volumen máximo:</div>
                        <div class="col-6">60 m3</div>
                    </div>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Conexión de agua:</div>
                        <div class="col-6">50mm</div>
                    </div>
                    <div class="row p-1">
                        <div class="col-6">Compatible con Wi-fi:</div>
                        <div class="col-6">SI</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-4">
            <div class="card"><img src={top}
                    class="card-img-top ps-5 pe-5" alt="..."/>
                <div class="card-body body-robots">
                    <h5 class="card-title text-center robot">TOP+19</h5>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Potencia:</div>
                        <div class="col-6">17,4 kW</div>
                    </div>
                    <div class="row  p-1">
                        <div class="col-6">Volumen máximo:</div>
                        <div class="col-6">80 m3</div>
                    </div>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Conexión de agua:</div>
                        <div class="col-6">50mm</div>
                    </div>
                    <div class="row p-1">
                        <div class="col-6">Compatible con Wi-fi:</div>
                        <div class="col-6">SI</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-4">
            <div class="card"><img src={top23} class="card-img-top ps-5 pe-5"
                    alt="..."/>
                <div class="card-body body-robots">
                    <h5 class="card-title text-center robot">TOP+23</h5>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Potencia:</div>
                        <div class="col-6">23 kW</div>
                    </div>
                    <div class="row  p-1">
                        <div class="col-6">Volumen máximo:</div>
                        <div class="col-6">100 m3</div>
                    </div>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Conexión de agua:</div>
                        <div class="col-6">50mm</div>
                    </div>
                    <div class="row p-1">
                        <div class="col-6">Compatible con Wi-fi:</div>
                        <div class="col-6">SI</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div> <br/>
    <div class="row p-2 ms-5 me-5 border-0 principalrow">
        <h5 class="card-title text-center robot pb-3 ">Bombas de calor NATACLOR - Mr. ECO</h5>
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-4">
            <div class="card"><img src={eco}
                    class="card-img-top ps-5 pe-5" alt="..."/>
                <div class="card-body body-robots">
                    <h5 class="card-title text-center robot">EPN07 - 230V</h5>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Potencia:</div>
                        <div class="col-6">7 kW</div>
                    </div>
                    <div class="row  p-1">
                        <div class="col-6">Volúmen máximo:</div>
                        <div class="col-6">30 m3</div>
                    </div>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Conexión de agua:</div>
                        <div class="col-6">50mm</div>
                    </div>
                    <div class="row p-1">
                        <div class="col-6">Compatible con Wi-fi:</div>
                        <div class="col-6">SI</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-4">
            <div class="card"><img src={eco}
                    class="card-img-top ps-5 pe-5" alt="..."/>
                <div class="card-body body-robots">
                    <h5 class="card-title text-center robot">EPN09 - 230V</h5>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Potencia:</div>
                        <div class="col-6">9 kW</div>
                    </div>
                    <div class="row  p-1">
                        <div class="col-6">Volumen máximo:</div>
                        <div class="col-6">45 m3</div>
                    </div>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Conexión de agua:</div>
                        <div class="col-6">50mm</div>
                    </div>
                    <div class="row p-1">
                        <div class="col-6">Compatible con Wi-fi:</div>
                        <div class="col-6">SI</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-4">
            <div class="card"><img src={eco}
                    class="card-img-top ps-5 pe-5" alt="..."/>
                <div class="card-body body-robots">
                    <h5 class="card-title text-center robot">EPN13 - 230V</h5>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Potencia:</div>
                        <div class="col-6">13 kW</div>
                    </div>
                    <div class="row  p-1">
                        <div class="col-6">Volumen máximo:</div>
                        <div class="col-6">65 m3</div>
                    </div>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Conexión de agua:</div>
                        <div class="col-6">50mm</div>
                    </div>
                    <div class="row p-1">
                        <div class="col-6">Compatible con Wi-fi:</div>
                        <div class="col-6">SI</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-4">
            <div class="card"><img src={eco}
                    class="card-img-top ps-5 pe-5" alt="..."/>
                <div class="card-body body-robots">
                    <h5 class="card-title text-center robot">EPN16 -230V</h5>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Potencia:</div>
                        <div class="col-6">16 kW</div>
                    </div>
                    <div class="row  p-1">
                        <div class="col-6">Volumen máximo:</div>
                        <div class="col-6">75 m3</div>
                    </div>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Conexión de agua:</div>
                        <div class="col-6">50mm</div>
                    </div>
                    <div class="row p-1">
                        <div class="col-6">Compatible con Wi-fi:</div>
                        <div class="col-6">SI</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-4">
            <div class="card"><img src={eco}
                    class="card-img-top ps-5 pe-5" alt="..."/>
                <div class="card-body body-robots">
                    <h5 class="card-title text-center robot">EPN20 -230V</h5>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Potencia:</div>
                        <div class="col-6">20,2 kW</div>
                    </div>
                    <div class="row  p-1">
                        <div class="col-6">Volumen máximo:</div>
                        <div class="col-6">90 m3</div>
                    </div>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Conexión de agua:</div>
                        <div class="col-6">50mm</div>
                    </div>
                    <div class="row p-1">
                        <div class="col-6">Compatible con Wi-fi:</div>
                        <div class="col-6">SI</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-4">
            <div class="card"><img src={eco}
                    class="card-img-top ps-5 pe-5" alt="..."/>
                <div class="card-body body-robots">
                    <h5 class="card-title text-center robot">EPN24 -230V</h5>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Potencia:</div>
                        <div class="col-6">24,2 kW</div>
                    </div>
                    <div class="row  p-1">
                        <div class="col-6">Volumen máximo:</div>
                        <div class="col-6">110 m3</div>
                    </div>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Conexión de agua:</div>
                        <div class="col-6">50mm</div>
                    </div>
                    <div class="row p-1">
                        <div class="col-6">Compatible con Wi-fi:</div>
                        <div class="col-6">SI</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div> <br/>
    <div class="row p-2 ms-5 me-5 border-0 principalrow">
        <h5 class="card-title text-center robot pb-3 ">Bombas de calor NATACLOR - Mr. SILENCE INVERPAD </h5>
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-4">
            <div class="card"><img src={silence}
                    class="card-img-top ps-5 pe-5" alt="..."/>
                <div class="card-body body-robots">
                    <h5 class="card-title text-center robot">MS130 - 230V</h5>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Potencia:</div>
                        <div class="col-6">13 kW</div>
                    </div>
                    <div class="row  p-1">
                        <div class="col-6">Volúmen máximo:</div>
                        <div class="col-6">65 m3</div>
                    </div>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Conexión de agua:</div>
                        <div class="col-6">50mm</div>
                    </div>
                    <div class="row p-1">
                        <div class="col-6">Compatible con Wi-fi:</div>
                        <div class="col-6">SI</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-4">
            <div class="card"><img src={silence}
                    class="card-img-top ps-5 pe-5" alt="..."/>
                <div class="card-body body-robots">
                    <h5 class="card-title text-center robot">MS170 - 230V</h5>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Potencia:</div>
                        <div class="col-6">17,5 kW</div>
                    </div>
                    <div class="row  p-1">
                        <div class="col-6">Volumen máximo:</div>
                        <div class="col-6">80 m3</div>
                    </div>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Conexión de agua:</div>
                        <div class="col-6">50mm</div>
                    </div>
                    <div class="row p-1">
                        <div class="col-6">Compatible con Wi-fi:</div>
                        <div class="col-6">SI</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-4">
            <div class="card"><img src={silence}
                    class="card-img-top ps-5 pe-5" alt="..."/>
                <div class="card-body body-robots">
                    <h5 class="card-title text-center robot">MS210 - 230V</h5>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Potencia:</div>
                        <div class="col-6">21 kW</div>
                    </div>
                    <div class="row  p-1">
                        <div class="col-6">Volumen máximo:</div>
                        <div class="col-6">95 m3</div>
                    </div>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Conexión de agua:</div>
                        <div class="col-6">50mm</div>
                    </div>
                    <div class="row p-1">
                        <div class="col-6">Compatible con Wi-fi:</div>
                        <div class="col-6">SI</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-4">
            <div class="card"><img src={silence}
                    class="card-img-top ps-5 pe-5" alt="..."/>
                <div class="card-body body-robots">
                    <h5 class="card-title text-center robot">MS280 -230V</h5>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Potencia:</div>
                        <div class="col-6">28 kW</div>
                    </div>
                    <div class="row  p-1">
                        <div class="col-6">Volumen máximo:</div>
                        <div class="col-6">120 m3</div>
                    </div>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Conexión de agua:</div>
                        <div class="col-6">50mm</div>
                    </div>
                    <div class="row p-1">
                        <div class="col-6">Compatible con Wi-fi:</div>
                        <div class="col-6">SI</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-4">
            <div class="card"><img src={silence}
                    class="card-img-top ps-5 pe-5" alt="..."/>
                <div class="card-body body-robots">
                    <h5 class="card-title text-center robot">MS280S -320V</h5>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Potencia:</div>
                        <div class="col-6">28 kW</div>
                    </div>
                    <div class="row  p-1">
                        <div class="col-6">Volumen máximo:</div>
                        <div class="col-6">120 m3</div>
                    </div>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Conexión de agua:</div>
                        <div class="col-6">50mm</div>
                    </div>
                    <div class="row p-1">
                        <div class="col-6">Compatible con Wi-fi:</div>
                        <div class="col-6">SI</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-4">
            <div class="card"><img src={silence}
                    class="card-img-top ps-5 pe-5" alt="..."/>
                <div class="card-body body-robots">
                    <h5 class="card-title text-center robot">MS350S -320V</h5>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Potencia:</div>
                        <div class="col-6">35,2 kW</div>
                    </div>
                    <div class="row  p-1">
                        <div class="col-6">Volumen máximo:</div>
                        <div class="col-6">160 m3</div>
                    </div>
                    <div class="row bg-secondary bg-opacity-25 p-1">
                        <div class="col-6">Conexión de agua:</div>
                        <div class="col-6">50mm</div>
                    </div>
                    <div class="row p-1">
                        <div class="col-6">Compatible con Wi-fi:</div>
                        <div class="col-6">SI</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
    </>
  )
}

export default BombasCalor